<app-navbar></app-navbar>
<app-home></app-home>
<app-about></app-about>
<app-our-services></app-our-services>
<!-- <app-work-process></app-work-process> -->
<app-projects></app-projects>
<!-- <app-our-team></app-our-team> -->
<app-contact></app-contact>
<app-footer></app-footer>
<router-outlet></router-outlet>